<div class="work-ui-avatar">
  <div [class.full-width]="fullWidth()"
       [class.square]="square()"
       [class]="size()"
       [ngClass]="status()"
       class="work-ui-avatar__image">
    @if (initials() && !imgSrc()) {
      <div class="work-ui-avatar__text">
        <h3 class="work-ui-avatar__text-element">{{ initials() }}</h3>
      </div>
    } @else {
      <img [alt]="alt() || 'Avatar'" [src]="effectiveImgSrc()">
    }
  </div>
</div>

